import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import { Box, capitalize, Skeleton, Typography } from '@mui/material';
import { Patient } from 'fhir/r4b';
import { FC } from 'react';
import { dataTestIds } from 'src/constants/data-test-ids';
import { formatDOB } from 'utils';
import { PATIENT_INDIVIDUAL_PRONOUNS_URL } from 'utils/lib/types';
import { getExtensionValue } from '../../../stores/appointment/parser/extractors';

type Props = {
  id?: string;
  patient: Patient | undefined;
  loading?: boolean;
};

import { useTranslation } from 'react-i18next';

export const Summary: FC<Props> = ({ patient, loading }) => {
  const { t } = useTranslation();
  const pronouns = getExtensionValue(patient, PATIENT_INDIVIDUAL_PRONOUNS_URL);

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      {loading ? <Skeleton width={86} /> : pronouns && <Typography>{pronouns}</Typography>}

      {loading ? (
        <Skeleton width={36} />
      ) : (
        patient?.gender && (
          <Typography data-testid={dataTestIds.patientHeader.patientBirthSex}>
            {capitalize(t(`patientProfile.gender.${patient.gender}`, { defaultValue: patient.gender }))}
          </Typography>
        )
      )}

      {loading ? (
        <Skeleton width={131} />
      ) : (
        patient?.birthDate && (
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <CakeOutlinedIcon fontSize="small" />
            <Typography data-testid={dataTestIds.patientHeader.patientBirthday}>
              {formatDOB(patient?.birthDate)
                ?.replace(' y', ` ${t('patientProfile.age.years')}`)
                .replace(' m', ` ${t('patientProfile.age.months')}`)
                .replace(' d', ` ${t('patientProfile.age.days')}`)}
            </Typography>
          </Box>
        )
      )}
    </Box>
  );
};

export default Summary;
